var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5561_174381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 2.85719L15.7143 2.85719C15.0223 2.8572 14.8283 2.85716 14.1071 2.85719L10.8036 2.85719C10.0419 2.85719 9.94196 2.85719 9.19643 2.85719L5.89286 2.85719C5.04314 2.85719 5.03065 2.85719 4.28572 2.85719L0.714286 2.85719C0.319196 2.85719 -5.58122e-08 3.17639 -1.24892e-07 3.57148L-2.37291e-06 16.4286C-2.44199e-06 16.8237 0.319194 17.1429 0.714283 17.1429L19.2857 17.1429C19.6808 17.1429 20 16.8237 20 16.4286L20 3.57148C20 3.17639 19.6808 2.85719 19.2857 2.85719ZM18.3929 15.5358L1.60714 15.5358L1.60714 4.46433L4.28571 4.46433C4.92499 4.46433 5.04583 4.46433 5.89286 4.46433L9.19643 4.46433C9.73214 4.46434 10.3169 4.46433 10.8036 4.46433L14.1071 4.46434C14.9158 4.46434 15.0907 4.46434 15.7143 4.46434L18.3929 4.46434L18.3929 15.5358Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2457 9.28589L12.1385 9.28589C12.0403 9.28589 11.96 9.36625 11.96 9.46446L11.96 10.5359C11.96 10.6341 12.0403 10.7145 12.1385 10.7145L16.2457 10.7145C16.3439 10.7145 16.4242 10.6341 16.4242 10.5359L16.4242 9.46446C16.4242 9.36625 16.3439 9.28589 16.2457 9.28589Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2457 12.3245L12.1385 12.3245C12.0403 12.3245 11.96 12.4048 11.96 12.503L11.96 13.5745C11.96 13.6727 12.0403 13.753 12.1385 13.753L16.2457 13.753C16.3439 13.753 16.4242 13.6727 16.4242 13.5745L16.4242 12.503C16.4242 12.4048 16.3439 12.3245 16.2457 12.3245Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2457 6.24707L12.1385 6.24707C12.0403 6.24707 11.96 6.32743 11.96 6.42564L11.96 7.49707C11.96 7.59528 12.0403 7.67564 12.1385 7.67564L16.2457 7.67564C16.3439 7.67564 16.4242 7.59528 16.4242 7.49707L16.4242 6.42564C16.4242 6.32743 16.3439 6.24707 16.2457 6.24707Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75314 7.37733L6.44064 10.5849L5.26207 8.95323C5.19511 8.85948 5.08796 8.8059 4.97413 8.8059L3.74868 8.8059C3.60359 8.8059 3.51877 8.97108 3.60359 9.08938L6.15046 12.6206C6.18334 12.6663 6.2266 12.7034 6.27666 12.7291C6.32673 12.7547 6.38217 12.7681 6.43841 12.7681C6.49465 12.7681 6.55009 12.7547 6.60016 12.7291C6.65022 12.7034 6.69348 12.6663 6.72636 12.6206L10.4094 7.51573C10.4942 7.39742 10.4094 7.23224 10.2643 7.23224L9.03886 7.23224C8.92725 7.23001 8.82011 7.28581 8.75314 7.37733Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5561_174381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.fe0bd90a956b1d88d0272214c19c1ff4.svg";
export { ForwardRef as ReactComponent };